import React from 'react';
import ReactDOM from 'react-dom/client';
import GettingStarted from './GettingStarted';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GettingStarted />
  </React.StrictMode>
);
